import type { TargetareUniversRand } from "@/types/targetare";
import { FILTRE_RAPIDE_FIRME } from "@/utils/targetareFiltreRapide";
import {
  coloaneImplicite,
  raportImplicit,
  type DefinitieRaport,
  type RaportSalvat,
} from "@/utils/targetareRaport";
import { COLOANE_TABEL } from "@/utils/targetareTabel";

export function rapoarteImpliciteFirme(): RaportSalvat[] {
  const standard = coloaneImplicite(COLOANE_TABEL);
  const sortareSalariati = [{ id: "salariati", desc: true }];
  return [
    raportImplicit("Raport principal", standard, { sortare: sortareSalariati }),
    raportImplicit("Firme cu email valid", standard, {
      filtre: [
        {
          id: "f-email",
          coloana: "email_principal",
          operator: "nu_este_gol",
          activ: true,
        },
      ],
      sortare: sortareSalariati,
    }),
    raportImplicit("Tier A privat", standard, {
      filtre: [
        {
          id: "f-tier",
          coloana: "tier",
          operator: "egal",
          valoare: "A",
          activ: true,
        },
        {
          id: "f-act",
          coloana: "actionariat",
          operator: "egal",
          valoare: "privat",
          activ: true,
        },
      ],
      sortare: sortareSalariati,
    }),
    raportImplicit(
      "Contacte și persoane",
      [
        "cui",
        "denumire",
        "judet",
        "localitate",
        "adresa",
        "site",
        "email_principal",
        "telefon_principal",
        "conducere",
        "director_it",
        "email_persoana",
      ],
      { sortare: [{ id: "denumire", desc: false }] }
    ),
    raportImplicit(
      "Surse de date",
      [
        "cui",
        "denumire",
        "judet",
        "sursa_onrc",
        "sursa_lista",
        "sursa_site",
        "sursa_web",
        "sursa_termene",
        "sursa_import",
        "sursa_manual",
        "sursa_nis2pass",
        "origine",
      ],
      { sortare: [{ id: "denumire", desc: false }] }
    ),
  ];
}

export const definitieRaportFirme: DefinitieRaport<TargetareUniversRand> = {
  cheie: "targetare.rapoarte",
  coloane: COLOANE_TABEL,
  rapoarteImplicite: rapoarteImpliciteFirme(),
  cheieRand: (r) => r.cui,
  filtreRapide: FILTRE_RAPIDE_FIRME,
  numeFisier: "targetare",
  mesajGol: "Nicio firmă nu corespunde filtrelor.",
};
